import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { getEventsList, getEventsTypeList, getList } from 'services/content-service'
import { EVENTS, GENERAL_EVENTS, SPORT_EVENTS } from 'constants/appConstants'
import View from './view'

const ContentType = ({ zone, searchMode, search, searchQuery, handleStatus, contentType }) => {
  const listInnerRef = useRef()
  const [currentPage, setCurrentPage] = useState(1)
  const [prevPage, setPrevPage] = useState(0)
  const [wasLastList, setWasLastList] = useState(false)
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setItems([])
    setCurrentPage(1)
    setPrevPage(0)
    setWasLastList(false)
  }, [contentType])

  useEffect(() => {
    if (!wasLastList && prevPage !== currentPage) {
      if (contentType === SPORT_EVENTS || contentType === GENERAL_EVENTS) {
        setIsLoading(true)
        getEventsTypeList(contentType, currentPage, zone)
          .then(response => {
            if (!response.data.data.length) {
              setWasLastList(true)
              return
            }
            setPrevPage(currentPage)
            setItems([...items, ...response.data.data])
          })
          .catch(err => console.log(err))
          .finally(() => setIsLoading(false))
      } else if (contentType === EVENTS) {
        setIsLoading(true)
        getEventsList(currentPage, zone)
          .then(response => {
            if (!response.data.data.length) {
              setWasLastList(true)
              return
            }
            setPrevPage(currentPage)
            setItems([...items, ...response.data.data])
          })
          .catch(err => console.log(err))
          .finally(() => setIsLoading(false))
      } else {
        setIsLoading(true)
        getList(contentType, currentPage, zone)
          .then(response => {
            if (!response.data.data.length) {
              setWasLastList(true)
              return
            }
            setPrevPage(currentPage)
            setItems([...items, ...response.data.data])
          })
          .catch(err => console.log(err))
          .finally(() => setIsLoading(false))
      }
    }
  }, [currentPage, wasLastList, prevPage, items])

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current
      if (scrollTop + clientHeight === scrollHeight) {
        setCurrentPage(currentPage + 1)
      }
    }
  }

  return (
    <View
      zone={zone}
      searchMode={searchMode}
      search={search}
      searchQuery={searchQuery}
      handleStatus={handleStatus}
      contentType={contentType}
      onScroll={onScroll}
      listInnerRef={listInnerRef}
      currentPage={currentPage}
      items={items}
      isLoading={isLoading}
    />
  )
}

ContentType.defaultProps = {
  search: [] || {},
  searchMode: false,
  handleStatus: () => {},
  searchQuery: '',
}

ContentType.propTypes = {
  zone: PropTypes.string.isRequired,
  search: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  searchMode: PropTypes.bool,
  handleStatus: PropTypes.func,
  contentType: PropTypes.string.isRequired,
  searchQuery: PropTypes.string,
}

export default ContentType
